module.exports = __webpack_public_path__ + "static/media/1.Portable Generator.204bbbce.jpg";